import styled from "styled-components";

export const ErrorContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  padding: 20px;
`;

export const ErrorDescription = styled.p`
  color: #666;
  max-width: 300px;
  text-align: center;
`;

export const ErrorMessage = styled.h1`
  color: #333;
`;
